import React from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface InventoryHeaderProps {
    totalProducts: number;
}

export const InventoryHeader: React.FC<InventoryHeaderProps> = ({ totalProducts }) => {
    const navigate = useNavigate();

    return (
        <div className="flex items-end justify-between gap-4 mb-6">
            <div>
                <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-slate-900">Products</h1>
                <p className="mt-1 text-sm text-slate-500">
                    {totalProducts.toLocaleString()} {totalProducts === 1 ? "product" : "products"} in your catalog
                </p>
            </div>
            <button
                onClick={() => navigate("../add-product")}
                className="inline-flex items-center gap-2 px-4 py-2.5 bg-slate-900 text-white rounded-lg text-sm font-semibold hover:bg-slate-800 transition-colors flex-shrink-0"
            >
                <Plus className="w-4 h-4" />
                <span className="hidden sm:inline">Add product</span>
                <span className="sm:hidden">Add</span>
            </button>
        </div>
    );
};
